import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Provider as AdminProvider } from '../sections/admin/context';
import { Spinner } from '../components/Spinner';
import { EnvironmentIdentifier } from '../components/EnvironmentIdentifier';

const Signal = lazy(() => import('../sections/signal/Signal'));

export function Mobile() {
  return (
    <AdminProvider>
      <EnvironmentIdentifier
        showBorder={false}
        sx={{ position: 'fixed', inset: 0 }}
      >
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route path="/signal/*" element={<Signal />} />
            <Route
              path="*"
              element={<Navigate to="/signal/fields" replace />}
            />
          </Routes>
        </Suspense>
      </EnvironmentIdentifier>
    </AdminProvider>
  );
}
